export const statisticsInfoItemStyle = {
	statistic: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',
		maxWidth: '162px',
		width: '100%',
		padding: '12px',
		background: 'var(--default-white)',
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow--1)',
	},

	icon: {
		marginBottom: '6px',
	},

	description: {
		color: 'var(--neutral-300)',
		fontSize: '14px',
		fontWeight: 400,
	},

	dropdown: {
		position: 'absolute',
		right: '12px',
		top: '12px',
	},

	action: {
		width: '100%',
		padding: '8px 16px',
		textTransform: 'capitalize',
		cursor: 'pointer',
		fontSize: '16px',
		lineHeight: '24px',
	},

	dropdownIcon: {
		'& .MuiButtonBase-root': {
			width: '16px',
			height: '16px',
			padding: 0,
		},
	},
};
